import app from 'xadmin'

import i18n from 'xadmin-i18n'
import form from 'xadmin-form'
import layout, { apps as uiApps } from 'xadmin-ui'
import model, { apps as modelApps } from 'xadmin-model'
import auth from 'xadmin-auth'

const { relate, filter, actions, search, modalform, reldetail } = modelApps
const { loading, splashscreen } = uiApps

export default app
  .use(i18n)
  .use(layout)
  .use(form)
  .use(model)
  .use(auth)
  .use(relate)
  .use(filter)
  .use(search)
  //.use(loading)
  .use(modalform)
  .use(actions)
  .use(reldetail)
  .use(splashscreen)
